(() => {
  const faq = document.querySelector('[data-faq-content]');
  if (!faq) return;

  const normalizeQuestion = (value) =>
    value
      .normalize('NFKD')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const answerTargets = new Map();

  faq.querySelectorAll('p, h1, h2, h3, h4, h5, h6').forEach((element) => {
    const strong = element.tagName === 'P' ? element.querySelector(':scope > strong:first-child') : null;
    const questionText = strong ? strong.textContent : element.textContent;
    const normalizedText = normalizeQuestion(questionText || '');

    if (normalizedText.endsWith('?') && !answerTargets.has(normalizedText)) {
      answerTargets.set(normalizedText, element);
    }
  });

  const linkedTargets = new Set();

  faq.querySelectorAll('a').forEach((link) => {
    if (normalizeQuestion(link.textContent || '') === 'back to top') {
      link.setAttribute('href', '#top');
    }
  });

  faq.querySelectorAll('a[href^="#"]:not([href="#"]):not([href="#top"])').forEach((link) => {
    const targetId = decodeURIComponent(link.hash.slice(1));
    if (!targetId || linkedTargets.has(targetId)) return;

    const answer = answerTargets.get(normalizeQuestion(link.textContent || ''));
    if (!answer) return;

    answer.id = targetId;
    answer.classList.add('faq-answer-anchor-target');
    linkedTargets.add(targetId);
  });

  if (window.location.hash) {
    const currentTarget = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (currentTarget?.classList.contains('faq-answer-anchor-target')) {
      requestAnimationFrame(() => currentTarget.scrollIntoView());
    }
  }
})();
